import { useEffect, useState } from 'react';
import styles from './SinlistModal.module.css';
import { SINList } from '../../../Models/SINList';
import { GetSelectedChemicals, SaveSinListItems, SearchSinList } from '../../../Api/Services/Alternative';
import LoadingIcon from '../../../components/LoadingIcon/LoadingIcon';
export default function SinlistModal({ id, handleClose }: {id: number, handleClose(): void}) {
    const [sinListItems, setSinListItems] = useState<SINList[]>([]);
    const [searchedSINListItems, setSearchedSINListItems] = useState<SINList[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        GetSelectedChemicals(id).then((data) => {
            setSinListItems(data);
        });
    }, []);

    const removeSINListItem = (id: number) => {
        setSinListItems(sinListItems.filter(item => item.chemicalId !== id));
    }
    const addSinlistItem = (item: SINList) => {
        item.selected = true;
        setSinListItems([...sinListItems, item]);
        setSearchedSINListItems(searchedSINListItems.filter(i => i.chemicalId !== item.chemicalId));
    }
    const handleSearch = () => {
        const query = (document.getElementById('sinlistSearch') as HTMLInputElement).value;
        if (query == "") {
            return;
        }
        setLoading(true);
        SearchSinList(id, query).then((data) => {
            if (data.length > 0) {
                setSearchedSINListItems(data);
            }
            setLoading(false);
        });
    }
    const saveSinlistItems = () => {
        SaveSinListItems(id, sinListItems).then(() => {
            handleClose();
        });
    }
    const handleSumbit = (e: any) => {
        e.preventDefault();
        handleSearch();
    }

    return(
        <div className={styles.backdrop}>
            <div className={styles.modal}>
                <h3>SIN List</h3>
                <table>
                    <thead>
                        <tr>
                            <th className={styles.cas}>CAS</th>
                            <th className={styles.name}>Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sinListItems.map((item) => (
                            <tr key={item.chemicalId}>
                                <td className={styles.cas}>{item.cas}</td>
                                <td className={styles.name}>{item.name}</td>
                                <td><button type="button" onClick={() => removeSINListItem(item.chemicalId)}>Remove</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <form onSubmit={(e) => handleSumbit(e)}>
                    <label htmlFor="sinlistSearch">Search SIN List</label>
                    <div>
                        <input type="text" name="sinlistSearch" id="sinlistSearch" />
                        <input type="button" className='button' value="Search" onClick={() => handleSearch()}/>
                    </div>
                </form>
                <table>
                    <thead>
                        <tr>
                            <th className={styles.cas}>CAS</th>
                            <th className={styles.name}>Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {searchedSINListItems.map((item) => (
                            <tr key={item.chemicalId}>
                                <td className={styles.cas}>{item.cas}</td>
                                <td className={styles.name}>{item.name}</td>
                                <td><button type="button" onClick={() => addSinlistItem(item)}>Add</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className={styles.flex}>
                    <button type="button" className="button" onClick={() => saveSinlistItems()}>Save</button>
                    <button type="button" className="button button_black" onClick={() => handleClose()}>Close</button>
                </div>
            </div>
            {loading && <LoadingIcon/>}
        </div>
    )
}